import React from 'react';
import { useIntl } from 'react-intl';

import { importComponent } from '@xingternal/hops';

type Props = {
  onClose: () => void;
  show: boolean;
};

const Dialog = importComponent(
  () => import('@xingternal/dialog'),
  ({ Dialog }) => Dialog
);

export const SearchAlertDialog: React.FC<Props> = ({ onClose, show = false }) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog
      show={show}
      headline={formatMessage({ id: 'JOBS_SEARCH_ALERTS_CREATE_ERROR_HEADLINE' })}
      text={formatMessage({ id: 'JOBS_SEARCH_ALERTS_CREATE_ERROR_TEXT' })}
      confirmLabel={formatMessage({ id: 'JOBS_SEARCH_ALERTS_CREATE_ERROR_CTA' })}
      onConfirm={onClose}
    />
  );
};
